module.exports = __webpack_public_path__ + "static/media/chinese_04.b2bd82dd.jpg";